module.exports = __webpack_public_path__ + "img/Inside-sp_14.d2b1303c.jpg";